__turbopack_context__.v({
  "className": "caveat_5a3b9936-module__NWYFYW__className",
});
